import { Avatar, Button, Divider, Dropdown, List, Menu, message, Radio, Select, Space } from 'antd';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/authContext';
import { CheckCircle, ClipboardList, ClipboardPen, LogOut, NotebookPen, Plus, Send, User2 } from 'lucide-react';
import { fetchProfile } from '../../service/api';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { editSelectedChild, getParentChildRecord } from '../../feature/parents/profiles/ProfileSlice';
import "../../style/page.css"


function ParentProfileMenu() {
    const dispatch = useDispatch()
    const { logoutStaffParent, user, getCurrentUser, userType } = useAuth()
    const { parentName, parentEmail, parentProfile } = user || {}
    const [open, setOpen] = useState(false);
    const navigate = useNavigate()
    const [selectedChild, setSelectedChild] = useState();
    const { childRecord, actionLoader } = useSelector((state) => state.parentProfile)

    const handleLogout = () => {
        logoutStaffParent()
        setOpen(false)
    }

    useEffect(() => {
        dispatch(getParentChildRecord())
    }, [])


    const menu = (
        <Menu
            className="custom-profile-dropdown"
            items={[
                {
                    key: '1',
                    // disabled: true,
                    label: (
                        <>
                            <h2>My Account </h2>
                            <hr />
                            <List itemLayout="horizontal">
                                <List.Item >
                                    <List.Item.Meta
                                        avatar={parentProfile ? <Avatar size={45} src={parentProfile} />
                                            : <Avatar src={`https://api.dicebear.com/7.x/miniavs/svg`} />
                                        }
                                        title={<Link to="/staff/profile-details" style={{ textDecoration: "line" }}>{parentName}</Link>}
                                        description={
                                            <div>
                                                <p>{parentEmail}</p>
                                            </div>
                                        }
                                    />
                                </List.Item>
                            </List>
                            <Divider style={{ margin: "8px 0" }} />
                        </>
                    ),
                },
                {
                    key: '2',
                    label: (
                        <p onClick={() => navigate('/parent/profile-details')}><User2 size={14} /> View Profile</p>
                    ),
                },
                {
                    key: '3',
                    label: (
                        <p onClick={() => navigate('/parent/aboutus')}><ClipboardList size={14} /> About us</p>
                    ),
                },
                {
                    key: '4',
                    label: (
                        <p onClick={() => navigate('/parent/privacy-policy')}><ClipboardPen size={14} /> Privacy Policy</p>
                    ),
                },
                {
                    key: '5',
                    label: (
                        <p onClick={() => navigate('/parent/term-condition')}><NotebookPen size={14} /> Terms & Conditions</p>
                    ),
                },
                {
                    key: '6',
                    label: (
                        <Button block onClick={handleLogout} danger icon={<LogOut size={16} />}>Logout</Button>
                    ),
                },

            ]}
        />
    );

    const handleChild = async (value) => {
        setSelectedChild(value)
        const resultAction = await dispatch(editSelectedChild({ childId: value }));
        if (editSelectedChild.fulfilled.match(resultAction)) {
            window.location.reload()
            localStorage.setItem("selectedChildId", value)
        } else {
            console.error("change child");
        }

    }
   

    useEffect(() => {
        if (childRecord?.childInfo?.length) {
            const selected =
                childRecord.childInfo.find(item => item.isSelectedChild) ||
                childRecord.childInfo[0]; // fallback

            setSelectedChild(selected._id);
            localStorage.setItem("selectedChildId", selected._id);
        }
    }, [childRecord]);

    return (

        <div className='parent_profile'>
            <Select loading={actionLoader} value={selectedChild}
                onChange={handleChild} style={{ width: "220px" }}
                variant="filled" placeholder="Select Child">
                {childRecord?.childInfo?.map((item) => (
                    <Select.Option key={item?._id} value={item?._id}>
                        <Space>
                            {item?.childImage ? <Avatar size={24} src={item?.childImage} /> : <Avatar size={24} src="https://api.dicebear.com/7.x/miniavs/svg" />}
                            {item?.childName}
                        </Space>
                    </Select.Option>
                ))}
            </Select>
            <Space direction="vertical">
                <Dropdown
                    open={open}
                    onOpenChange={setOpen}
                    overlay={menu} placement="bottomRight" trigger={['click']}>
                    <Space style={{ cursor: "pointer" }}>
                        <h3> Welcome,🎉 {parentName || "Guest"}  </h3>
                        {parentProfile ? <Avatar size={36} src={parentProfile} />
                            : <Avatar size={36} icon={<User2 size={20} />} />}
                    </Space>
                </Dropdown>
            </Space>
        </div>
    )
}



export default ParentProfileMenu